<template>
  <div id="grid-progresoPA">
    <v-flex>
      <v-toolbar color="white" dark flat dense cad>
        <v-toolbar-title class="indigo--text"
          >Progreso preguntas abiertas</v-toolbar-title
        >
      </v-toolbar>
    </v-flex>
    <v-container grid-list-xl fluid>
      <v-layout>
        <carga-masiva-asincrona
          v-if="usuarioLoggedTipe != 'AGENCIA'"
          :apiValidateDocument="apiValidateDocument"
          :apiSaveDocument="apiSaveDocument"
          :apiDownloadDocument="apiDownloadDocument"
          :templateTitle="templateTitle"
          :tipoCarga="tipoCarga"
        ></carga-masiva-asincrona>
      </v-layout>
      <v-layout justify-center>
        <v-flex xs12 md6>
          <v-select
            v-model="nivelValue"
            :items="nivelSelect"
            item-text="name"
            item-value="code"
            label="Nivel"
          ></v-select>
        </v-flex>
        <v-flex xs12 md8>
          <v-select
            v-model="tipoPruebaValue"
            :items="tipoPruebaSelect"
            label="Tipo Prueba"
          >
          </v-select>
        </v-flex>
        <v-flex xs12 md4>
          <v-menu
            v-model="menu1"
            :close-on-content-click="false"
            :nudge-right="40"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="fechaInicioFormatted"
                label="Día de carga"
                prepend-icon="event"
                v-on="on"
                @blur="fechaValue = parseDate(fechaInicioFormatted)"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="fechaValue"
              @input="menu1 = false"
              no-title
              locale="es"
              first-day-of-week="1"
            ></v-date-picker>
          </v-menu>
        </v-flex>

        <v-btn
          fab
          dark
          color="teal"
          title="Filtrar detalle"
          @click="loadData()"
        >
          <v-icon dark>filter_list</v-icon>
        </v-btn>
        <v-btn
          fab
          dark
          color="red darken-4"
          title="Limpiar filtros"
          @click="clear()"
        >
          <v-icon dark>clear_all</v-icon>
        </v-btn>
      </v-layout>
      <v-layout>
        <v-flex lg12>
          <div v-if="loading">
            <loading></loading>
          </div>
          <div v-if="alerta">
            <alert-empty></alert-empty>
          </div>
          <v-spacer></v-spacer>
          <template>
            <v-data-table
              :headers="headers"
              :items="datosPaginados"
              :page.sync="page"
              :rows-per-page-items="rowsPerPageItems"
              :pagination.sync="pagination"
              @page-count="pageCount = $event"
              class="elevation-1"
              hide-actions
            >
              <template v-slot:items="props">
                <tr>
                  <td class="text-xs-left">{{ props.item.nivel }}</td>
                  <td class="text-xs-left">{{ props.item.tipoPrueba }}</td>
                  <td class="text-xs-left">{{ props.item.asignatura }}</td>
                  <!-- <td class="text-xs-left">{{ props.item.forma}}</td> -->
                  <td class="text-xs-left">{{ props.item.cantidad }}</td>
                  <td class="text-xs-left">{{ props.item.fechaEjecucion }}</td>
                </tr>
              </template>
            </v-data-table>

            <v-flex xs12 sm6>
              <v-text-field
                value=""
                label="Total de Registros"
                v-model="cantRegistros"
                disabled
              ></v-text-field>
            </v-flex>
            <div class="text-center pt-2">
              <v-pagination
                @input="changePage(page)"
                v-model="page"
                :length="pageCount"
                :total-visible="9"
                circle
              >
              </v-pagination>
            </div>

            <v-card-actions class="pb-3">
              <v-spacer></v-spacer>
              <v-btn
                :disabled="botonDescarga"
                :loading="loading"
                color="primary"
                @click="descarga()"
                >Descarga progreso preguntas abiertas<v-icon right dark
                  >folder</v-icon
                ></v-btn
              >
              <v-spacer></v-spacer>
            </v-card-actions>
          </template>

          <v-dialog v-model="dialogLoading" persistent max-width="390">
            <loading-descarga></loading-descarga>
          </v-dialog>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>
<script>
import axios from "axios";
import Loading from "@/views/ui/Loading.vue";
import AlertEmpty from "@/views/ui/AlertEmpty.vue";
import CargaMasivaAsincrona from "@/components/CargaMasivaAsincrona.vue";
import LoadingDescarga from "@/views/ui/LoadingDescarga.vue";
import { misMixins } from "@/mixins/myMixing.js";

export default {
  name: "grid-progresoPA",

  components: {
    AlertEmpty,
    Loading,
    CargaMasivaAsincrona,
    LoadingDescarga,
  },
  mixins: [misMixins],
  props: {},

  data() {
    return {
      botonDescarga: true,
      loading: false,
      alerta: false,
      dialogLoading: false,
      id: "",
      totalRegistro: "",
      idContrato: "",
      headers: [
        { text: "Nivel", align: "left", sortable: false, value: "" },
        { text: "Tipo Prueba", sortable: false, value: "" },
        { text: "Asignatura", sortable: false, value: "" },
        // { text: "Forma", sortable: false, value: "" },
        { text: "Cantidad", sortable: false, value: "" },
        { text: "Día de carga", sortable: false, value: "" },
      ],
      itemsProgreso: [],
      idUserLogged: "",
      //filtros
      nivelSelect: [],
      nivelValue: null,
      tipoPruebaSelect: [],
      tipoPruebaValue: null,
      menu1: false,
      fechaValue: null,
      fechaInicioFormatted: null,
      //----CARGA MASIVA---
      apiValidateDocument: "/preguntasAbiertas/preProcessFileProgreso",
      apiSaveDocument: "/preguntasAbiertas/saveFileMassiveProgreso",
      apiDownloadDocument: "/preguntasAbiertas/downloadTemplateProgreso/",
      templateTitle: "PlantillaProgresoPreguntasAbiertas",
      tipoCarga: "CSV",

      page: 1,
      pageCount: 0,
      datosPaginados: [],
      paginaActual: 1,
      cantRegistros: 0,
      rowsPerPageItems: [20],
      pagination: {
        page: 1,
        rowsPerPage: 50,
        pages: 0,
      },
      totalPages: 0,
      totalRegistros: "",
    };
  },
  watch: {
    dialogLoading(val) {
      if (!val) return;
      setTimeout(() => (this.dialogLoading = false), 5000);
    },
    fechaValue(val) {
      this.fechaInicioFormatted = this.formatDate(this.fechaValue);
    },
  },

  created() {
    // console.log("progresoPreguntas");

    this.idContrato = this.$store.getters.contratoStored;
    this.tab = this.$store.getters.subTabSelectedStored;
    this.usuarioLoggedTipe = this.$store.getters.userLogged.tipo;

    this.loadData();
  },
  mounted() {},
  methods: {
    descarga() {
      this.dialogLoading = true;
      let fileName = "Descarga_progreso_PA.xlsx";

      var url = "/preguntasAbiertas/descargaProgreso";
      this.body = {
        nivel: this.nivelValue,
        tipoPrueba: this.tipoPruebaValue,
        idContrato: this.idContrato,
        fechaEjecucion:
          this.fechaValue && this.fechaValue != null
            ? this.formatDate(this.fechaValue)
            : null,
      };
      axios
        .post(url, this.body, {
          responseType: "blob",
        })
        .then(function (response) {
          const urle = window.URL.createObjectURL(response.data);
          const link = document.createElement("a");
          link.href = urle;
          link.setAttribute("download", fileName);
          document.body.appendChild(link);
          link.click();
          return response.data;
        })
        .catch(function (error) {
          console.log(error);
          return [];
        });
    },
    async loadProgresoPA() {
      this.body = {
        nivel: this.nivelValue,
        tipoPrueba: this.tipoPruebaValue,
        idContrato: this.idContrato,
        fechaEjecucion:
          this.fechaValue && this.fechaValue != null
            ? this.formatDate(this.fechaValue)
            : null,
        pageSize: 20,
        pageNumber: this.page,
      };
      return await axios
        .post("/preguntasAbiertas/getResumenProgreso/", this.body)
        .then(function (response) {
          return response.data;
        })
        .catch((error) => {
          if (error) {
            console.log(error.response.data);
          }
          return [];
        });
    },

    async loadData() {
      this.loading = true;

      this.itemsProgreso = await this.loadProgresoPA();

      if (this.itemsProgreso.length > 0) {
        this.cantRegistros = this.itemsProgreso.length;
        this.pageCount = Math.ceil(
          this.itemsProgreso.length / this.rowsPerPageItems
        );
        this.getDataPagina(this.page);

        this.alerta = false;
        this.botonDescarga = false;
      } else {
        this.alerta = true;
        this.botonDescarga = true;
        this.datosPaginados = [];
        this.cantRegistros = 0;
        this.pageCount = 0;
      }
      this.loadNivelSelect();
      this.loadTipoPruebaSelect();
      this.loading = false;
    },
    loadNivelSelect() {
      let niv = [];
      this.itemsProgreso.forEach(function (c) {
        let index = niv.findIndex((x) => x.nivel == c.nivel);
        if (index === -1) {
          if (c.nivel != null && c.nivel != "") {
            niv.push(c.nivel);
          }
        }
      });
      this.nivelSelect = niv;
    },
    loadTipoPruebaSelect() {
      let tip = [];
      this.itemsProgreso.forEach(function (d) {
        let index = tip.findIndex((x) => x.tipoPrueba == d.tipoPrueba);
        if (index === -1) {
          tip.push(d.tipoPrueba);
        }
      });
      this.tipoPruebaSelect = tip;
    },
    clear() {
      this.fechaValue = null;
      this.nivelValue = null;
      this.tipoPruebaValue = null;
      this.loadData();
    },

    // paginacion
    changePage(page) {
      this.page = page <= 0 || page > this.pages ? this.page : page;
      this.getDataPagina(this.page);
    },
    getDataPagina(noPagina) {
      this.paginaActual = noPagina;
      this.datosPaginados = [];

      let ini = noPagina * this.rowsPerPageItems - this.rowsPerPageItems;
      let fin = noPagina * this.rowsPerPageItems;
      this.datosPaginados = this.itemsProgreso.slice(ini, fin);
    },
    getDataFull() {
      this.datosPaginados = [];
      this.page = 1;
      this.datosPaginados = this.itemsProgreso.slice(
        0,
        this.itemsProgreso.length
      );
    },
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${day}-${month}-${year}`;
    },
    parseDate(date) {
      if (!date) return null;

      const [day, month, year] = date.split("-");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },
  },
};
</script>
